module.exports = __webpack_public_path__ + "static/media/pickupHero.3785f6ff.png";